import React, { useState, useRef, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { BROADCAST } from "common/viewContent";
import * as Path from "routes/Path/index";
import BroadcastUserList from "../../components/Modals/BroadcastUserList/index";
import { Link, useLocation,useNavigate } from "react-router-dom";
import MessageList from "./detail/MessageList";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

const Message = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.row;
  console.log("data==>", rowData);
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [show, setShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (rowData) {
      document.getElementById('main-content')?.scrollTo(0, 0);
      setMessage(rowData?.msg);
      setSubject(rowData?.subject);
      setAttachment(rowData?.attachment);
    }
  }, [rowData]);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          toast.error("File size exceeds the limit of 10 MB", {
            position: "top-right",
          });
        } else {
          setImage(URL.createObjectURL(event.target.files[0]));
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (event.target.files[0].type == "image/jpeg") {
            setFileType("jpeg");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("png");
          }
        }
      } else {
        toast.error(
          "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          { position: "top-right" }
        );
      }
    }
  };

  const handleMessage = (e) => {
    e.preventDefault();
    setShow(true);
  };
  const clearInput = () => {
    setMessage("");
    setSubject("");
    emptyImage();
    if (rowData) {
      navigate("/admin/broadcast", { replace: true });
    }
    setAttachment(null);
  };
  const handleClose = () => {
    setShow(false);
  };

  const toolbarOptions = [
    [{ header: [1, 2, 3, false] }], // Header styles
    ["bold", "italic", "underline", "strike"],
    // [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: ["", "center", "right", "justify"] }],
    ["blockquote", "code-block"],
    ["link"],
    ["clean"],
  ];
  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };
  return (
    <>
      {show && (
        <BroadcastUserList
          show={show}
          handleClose={handleClose}
          title={BROADCAST.TOP_CONTENT}
          message={message}
          clearInput={clearInput}
          setIsSuccess={setIsSuccess}
          subject={subject}
          uploadImage={uploadImage}
          fileType={fileType}
          attachment={attachment}
        />
      )}
      <Helmet title={BROADCAST.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{BROADCAST.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{BROADCAST.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{BROADCAST.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form className="px-3" onSubmit={handleMessage}>
                  <div className="card-header row">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2">
                      <label className="m-0" style={{ fontSize: 12 }}>
                        Subject:
                      </label>
                      <input
                        className="form-control"
                        name="subject"
                        onChange={(e) => setSubject(e.target.value)}
                        value={subject}
                        placeholder="Enter Subject"
                      />
                    </div>

                    <div className="my-1 py-3">
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        <div
                          className="position-relative p-3 rounded w-100 d-flex align-items-center justify-content-center"
                          style={{
                            border: "1px dashed #9d9d9d",
                            // maxWidth: 400,
                            height: 130,
                            background: "#f1f1f1",
                          }}
                        >
                          {image && (
                            <Button
                              onClick={emptyImage}
                              className="border-0 position-absolute text-white  rounded-circle p-2 d-flex align-items-center justify-content-center"
                              style={{
                                top: 0,
                                right: 0,
                                zIndex: 999,
                                transform: "translateY(-50%)",
                                background: "#216fc8",
                                height: 30,
                                width: 30,
                              }}
                              variant="transparent"
                            >
                              X
                            </Button>
                          )}
                          <input
                            type="file"
                            ref={fileInputRef}
                            onChange={onImageChange}
                            style={{ left: 0, top: 0, zIndex: 99, opacity: 0 }}
                            className="position-absolute h-100 w-100 file"
                          />
                          <div className="text-center">
                            {image && (
                              <img
                                src={
                                  (fileType == "pdf" &&
                                    "/assets/images/pdf.png") ||
                                  (fileType == "text" &&
                                    "/assets/images/txtIcon.png") ||
                                  (fileType == "doc" &&
                                    "/assets/images/doc.png") ||
                                  (fileType == "xlsx" &&
                                    "/assets/images/xlsx.jpg") ||
                                  image
                                }
                                alt=""
                                className="img-fluid mx-auto object-fit-contain"
                                style={{ height: 80 }}
                              />
                            )}
                            {uploadImage === null && (
                              <>
                                <div className="text-center">
                                  {uploadIcn}
                                  <p className="m-0 text-muted">Upload File</p>
                                  {/* <p
                                    className="m-0 text-muted"
                                    style={{ fontSize: 12, lineHeight: 1 }}
                                  >
                                    Doc, Png, jpg
                                  </p> */}
                                </div>
                              </>
                            )}
                            <div className="text-center">
                              {" "}
                              <p className="m-0 text-muted">{fileType}</p>
                            </div>
                          </div>
                        </div>
                        {/* <button className="search-btn" type="button" onClick={onSubmit12}>
                <img src={process.env.PUBLIC_URL + "/assets/images/icon/send1.svg"} alt="search" />
              </button> */}
                      </div>
                    </div>
                    {attachment && (
                      <div className="mt-3 w-100">
                        <label style={{fontSize: 12}} className="mb-0 me-2">Attachment:</label>
                        <span className="d-inline-flex align-items-center gap-2">
                          <a
                            href={attachment}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary text-decoration-underline"
                          >
                            {attachment.split("/").pop()}
                          </a>
                          <button
                            onClick={() => setAttachment(null)}
                            className="btn btn-sm btn-outline-danger p-1 rounded-circle"
                            style={{ fontSize: 12, lineHeight: 1 }}
                          >
                            ✕
                          </button>
                        </span>
                      </div>
                    )}

                    <div className="col-md-12 my-2">
                      <label className="m-0" style={{ fontSize: 12 }}>
                        Message:
                      </label>
                      <ReactQuill
                        value={message}
                        onChange={setMessage}
                        placeholder="Enter your message"
                        modules={{
                          toolbar: toolbarOptions,
                        }}
                        formats={[
                          "header",
                          "bold",
                          "italic",
                          "underline",
                          "strike",
                          "blockquote",
                          "code-block",
                          "list",
                          "bullet",
                          "link",
                          "align",
                          "color",
                          "background",
                        ]}
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button
                        type="submit"
                        disabled={!message || !subject}
                        className="btn btn-primary btn-lg"
                      >
                        Send
                      </button>
                      <button
                        onClick={() => clearInput()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <MessageList isSuccess={isSuccess} setIsSuccess={setIsSuccess} />
        </div>
      </section>
    </>
  );
};

export default Message;

const uploadIcn = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 13.5V10.5H10.5L8 7.5L5.5 10.5H7.5V13.5H5V13.475C4.916 13.48 4.836 13.5 4.75 13.5C3.75544 13.5 2.80161 13.1049 2.09835 12.4017C1.39509 11.6984 1 10.7446 1 9.75C1 7.826 2.455 6.258 4.322 6.043C4.48569 5.1873 4.94245 4.41538 5.61371 3.86001C6.28497 3.30464 7.12878 3.00053 8 3C8.87134 3.00048 9.71529 3.30454 10.3867 3.8599C11.0582 4.41526 11.5151 5.18721 11.679 6.043C13.546 6.258 14.999 7.826 14.999 9.75C14.999 10.7446 14.6039 11.6984 13.9007 12.4017C13.1974 13.1049 12.2436 13.5 11.249 13.5C11.165 13.5 11.084 13.48 10.999 13.475V13.5H8.5Z"
      fill="#828282"
    />
  </svg>
);
